var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Icon',{attrs:{"icon":_vm.iconFor(_vm.status),"iconColor":_vm.colorFor(_vm.status),"tooltipText":_vm.labelFor(_vm.status),"margin":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }